import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const Contact: React.FC = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box sx={{ maxWidth: '800px', mx: 'auto', px: 3, py: 4 }}>
      {/* Hero */}
      <Box sx={{ mb: 6 }}>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '36px', sm: '48px' },
            fontWeight: 700,
            lineHeight: 1.1,
            mb: 2,
            color: theme.palette.text.primary,
            letterSpacing: '-0.02em',
          }}
        >
          Get in Touch
        </Typography>
        <Typography
          sx={{
            fontSize: '18px',
            color: theme.palette.text.secondary,
            fontWeight: 500,
          }}
        >
          Have questions, feedback, or just want to say hi?
        </Typography>
      </Box>

      {/* Content Sections */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        {/* Email Section */}
        <Box>
          <Typography
            variant="h5"
            sx={{
              fontSize: '24px',
              fontWeight: 700,
              mb: 2,
              color: theme.palette.text.primary,
            }}
          >
            Contact
          </Typography>
          <Typography
            sx={{
              fontSize: '16px',
              lineHeight: 1.7,
              color: theme.palette.text.secondary,
              mb: 2,
            }}
          >
            Hi! I built this tool because I'm interested in the therapeutic nature of music and understanding how
            we interact with the music we choose to listen to. I'd love to hear from you — whether you have questions about emotify,
            feedback and suggestions, or just want to share your musical discoveries, feel free to reach out.
          </Typography>
          <Box
            sx={{
              p: 3,
              borderRadius: '16px',
              background: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
              border: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Typography
              component="a"
              href="mailto:emotify.dev@gmail.com"
              sx={{
                fontSize: '18px',
                color: theme.palette.text.primary,
                textDecoration: 'none',
                fontWeight: 600,
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              emotify.dev@gmail.com
            </Typography>
          </Box>
        </Box>

      </Box>
    </Box>
  );
};

export default Contact;
